import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customInstance } from '@/common/infrastructure/http/apiClient';
import type { ProblemDetails } from '@/common/infrastructure/http/problemDetails';
import { ConflictError } from '@/common/infrastructure/http/problemDetails';
import { SUPPRESS_GLOBAL_ERROR_TOAST } from '@/common/application/constants/mutationMeta';
import { blocksQueryKey } from '@/blocks/application/hooks/useBlocks';

export const useArchiveBlock = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // The library page and the editor render the failure themselves; no second toast in the CRM host.
    meta: SUPPRESS_GLOBAL_ERROR_TOAST,
    mutationFn: async (id: string): Promise<void> => {
      try {
        await customInstance<void>({
          url: `/api/pdf-templates/v1/blocks/${id}/archive`,
          method: 'POST'
        });
      } catch (err) {
        if (err instanceof ConflictError) throw err;

        const problem = (err as { problem?: ProblemDetails })?.problem;
        if (problem) throw new ConflictError(problem);
        throw err;
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: blocksQueryKey,
        refetchType: 'all'
      });
    }
  });
};
